import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window to the top whenever the route changes.
 * Place once inside <BrowserRouter> in App.js.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
